// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"OfflinePage_PageHolder__s8LOg","ImageHolder":"OfflinePage_ImageHolder__18ezL","TextHolder":"OfflinePage_TextHolder__cFdqf"};